export const growthNumber = (value) => {
  const number = Number(String(value ?? "").trim().replace(",", "."));
  return Number.isFinite(number) ? number : 0;
};

const timestamp = (value) => {
  if (!value) return 0;
  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
};

const measurementDateTime = (record) => {
  const date = String(record?.date || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return 0;
  return timestamp(`${date}T12:00:00.000Z`);
};

const mutationTime = (record) => timestamp(
  record?.updatedAt
  || record?.updated_at
  || record?.createdAt
  || record?.created_at
);

export const compareGrowthRecords = (left, right) => {
  const measurementDifference = measurementDateTime(left) - measurementDateTime(right);
  if (measurementDifference) return measurementDifference;

  const mutationDifference = mutationTime(left) - mutationTime(right);
  if (mutationDifference) return mutationDifference;

  return String(left?.id || "").localeCompare(String(right?.id || ""), undefined, { numeric: true });
};

export const growthMetricEntries = (records = [], key) => records
  .map((record) => ({ record, value: growthNumber(record?.[key]) }))
  .filter((entry) => entry.value > 0)
  .sort((left, right) => compareGrowthRecords(left.record, right.record));

export const latestGrowthMetric = (records, key) => {
  const entries = growthMetricEntries(records, key);
  return entries[entries.length - 1] || null;
};
